import {
  createAsyncActionTypes,
  createActionTypes,
} from '../../util/createLifeomicActionTypes';

const asyncActions = createAsyncActionTypes([
  'SURVEYS_FETCH_SURVEY',
  'SURVEYS_FETCH_SURVEYS',
  'SURVEYS_FETCH_SURVEY_RESPONSE',
  'SURVEYS_FETCH_SURVEY_RESPONSE_PATIENTS',
  'SURVEYS_FETCH_SURVEY_RESPONSES',
  'SURVEYS_FETCH_PATIENT',
  'SURVEYS_SEND_SURVEY',
  'SURVEYS_UPDATE_RESPONSE',
  'SURVEYS_DELETE_RESPONSE',
  'SURVEYS_CREATE_SURVEY',
  'SURVEYS_UPDATE_SURVEY',
  'SEND_SURVEY_INVITE_TO_NEW_SUBJECT',
  'SEND_SURVEY_INVITE_TO_EXISTING_SUBJECT',
  'SURVEYS_CREATE_RESPONSE',
  'SURVEYS_CREATE_SHAREABLE_INVITE_LINK',
  'SURVEYS_ACCEPT_OPEN_SURVEY_INVITE',
]);

const actions = createActionTypes([
  'SURVEYS_CLEAR_SURVEY_DETAIL',
  'SURVEYS_SET_SURVEY_DETAIL_SURVEY',
  'SURVEYS_SET_SURVEY_RESPONSES',
  'SURVEYS_SET_SURVEY_DETAIL_PATIENTS',
  'SURVEYS_INITIALIZATION_START',
  'SURVEYS_INITIALIZATION_END',
  'SURVEYS_APPEND_NEW_RESPONSE_TO_DETAILS',
  'SURVEYS_SET_USER_SURVEY_INITIALIZING',
  'SURVEYS_SET_USER_RESPONSES',
  'SURVEYS_ADD_USER_SURVEYS',
  'SURVEYS_RESET_USER_SURVEY_STATE',
]);

export default {
  ...asyncActions,
  ...actions,
};
